import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import useAuthStore from '../stores/authStore';
import useEventsStore from '../stores/eventsStore';
import toast from 'react-hot-toast';

export function useWebSocket() {
  const queryClient = useQueryClient();
  const wsOdds = useRef(null);
  const wsBets = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('jwt_token');
    if (!token) return;

    const wsUrl = import.meta.env.VITE_WS_URL || 'wss://api.example.com/ws/v1';

    wsOdds.current = new WebSocket(`${wsUrl}/odds?token=${token}`);
    wsOdds.current.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      if (msg.type === 'odds_update') {
        useEventsStore.getState().updateOdds(msg.market_id, {
          home_odds: msg.home_odds,
          draw_odds: msg.draw_odds,
          away_odds: msg.away_odds,
          status: msg.status,
        });
        queryClient.setQueriesData({ queryKey: ['events'] }, (old) => {
          if (!old) return old;
          return {
            ...old,
            events: old.events.map((e) => {
              if (e.id !== msg.event_id) return e;
              return {
                ...e,
                markets: e.markets.map((m) => (m.id === msg.market_id ? { ...m, ...msg } : m)),
              };
            }),
          };
        });
      }
      if (msg.type === 'market_suspended') {
        toast.warning(`Mercado suspenso: ${msg.reason || 'evento iniciou'}`);
        queryClient.invalidateQueries({ queryKey: ['events'] });
      }
    };

    wsBets.current = new WebSocket(`${wsUrl}/bets?token=${token}`);
    wsBets.current.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      if (msg.type === 'bet_settled') {
        toast.success(`Aposta #${msg.bet_id} ${msg.status === 'won' ? 'ganhou' : 'perdeu'}!`);
        useAuthStore.getState().updateBalance(msg.new_balance);
        queryClient.invalidateQueries({ queryKey: ['bets'] });
      }
      if (msg.type === 'bet_accepted') {
        toast.success(`Aposta aceita #${msg.bet_id}`);
      }
      if (msg.type === 'balance_update') {
        useAuthStore.getState().updateBalance(msg.new_balance);
      }
    };

    const heartbeat = setInterval(() => {
      if (wsOdds.current?.readyState === WebSocket.OPEN) {
        wsOdds.current.send(JSON.stringify({ action: 'ping' }));
      }
      if (wsBets.current?.readyState === WebSocket.OPEN) {
        wsBets.current.send(JSON.stringify({ action: 'ping' }));
      }
    }, 25000);

    return () => {
      clearInterval(heartbeat);
      wsOdds.current?.close();
      wsBets.current?.close();
    };
  }, [queryClient]);
}
